import React, { useEffect, useState } from 'react';
import { Form, Typography, Row, Input, Table, message } from 'antd';
import GenericModal from '../../buttons/genericModal';
import { backendPatchWithoutRefresh } from '../../../helpers/callBackend';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

const { Text } = Typography;

function UpdateAccountNumbers(props) {
	const [submitting, setSubmitting] = useState(false);
	const [bankAccounts, setBankAccounts] = useState(props.bankAccounts || []);

    const onFormSubmitModal = () => {
        if (bankAccounts.some(bankAccount => bankAccount.source === 'UN')) {
            message.error('Cannot update details of arpari bank accounts');
            return;
        }
        const data = bankAccounts.map(bankAccount => ({
            bank_account_id: bankAccount.bankId,
            account_number: bankAccount.accountNumber,
        }));
        setSubmitting(true);
        backendPatchWithoutRefresh("/api/bank-account/multi/", { accountParams: data })
        .then((response) => {
            if (response.status === 200) {
                setSubmitting(false);
                props.handleCancelModal();
                message.success(response.data.description);
            } else {
                setSubmitting(false);
                message.error(response.response.data.description);
            }
        })
    };
     
    useEffect(() => {
        setBankAccounts(props.bankAccounts || []);
    }, [props, props.bankAccounts]);

    useEffect(() => {
		return () => {
			props.handleCancelModal();
		};
	}, []);

    const deleteRow = (bankAccountId) => {
		setBankAccounts((prevState) => {
			const newSelectedRows = prevState.filter((account) => {
				return account.key !== bankAccountId
			})
			return newSelectedRows;
		});
	}

	const updateRow = (value, bankAccountId, field) => {
		setBankAccounts((prevState) => {
			const newSelectedRows = prevState.map((account) => {
				if (account.key === bankAccountId) {
					return {
						...account,
						[field]: value,
					}
				}
				return account;
			});
		 	return newSelectedRows;
		});
	}

    const columns = [
        {
			title: 'Bank',
			dataIndex: 'institution',
			key: 'institution',
		},
		{
			title: 'Account Name',
			dataIndex: 'account',
			key: 'account',
			render: (text, record) => {
				let ret = record.account;
				const last4 = record.last4;
				if (last4 !== undefined 
                    && last4.length > 3
					&& last4.length < 7 
                    && !ret.includes(last4)) {
					ret = `${ret} (...${last4})`
				}
				return ret;
			}
		},
		{
			title: 'Entity',
			dataIndex: 'entityName',
			key: 'entityName',
		},
        {
            title: 'Account Number',
            dataIndex: 'accountNumber',
            key: 'accountNumber',
            render: (text, record) => (
                <Form.Item
                    name={`accountNumber${record.key}`}
                    style={{ marginTop: 24 }}
                    rules={[{ required: true, message: 'Account number is required' }]}
                >
                    <Input 
                        placeholder={"Account number"}
                        value={record.accountNumber} 
                        onChange={(e) => updateRow(e.target.value, record.key, "accountNumber")}
                    />
                </Form.Item>
            )
        },
		{
			title: '',
			key: 'remove',
			render: (text, record) => 
				<Button
					sx={{ fontSize: 12, width: '100%', textTransform: 'none' }}
					disableElevation fullWidth size="small" type="submit" variant="outlined" color="secondary"
					onClick={() => deleteRow(record.key)}
				>Remove</Button>,
		},
	];

	return (
		<GenericModal
			size='xl'
			visible={props.visible}
			handleCancelModal={() => props.handleCancelModal()}
			showModal={() => props.handleShowModal()}
			modalTitle="Update Account Numbers"
			modalBody={
				<Form
					layout="vertical"
					name="basic"
					onFinish={onFormSubmitModal}
					autoComplete="off"
				>
					<Row style={{ marginBottom: "20px" }}>
						<Text>
                            Update account numbers of the following bank account(s).
						</Text>
					</Row>
					<Table
						columns={columns}
						dataSource={bankAccounts}
					/>					
                    <Form.Item>
						<LoadingButton
							htmlType="submit"
							loading={submitting}
							loadingPosition='start'
							style={{ margin: "3px", width: "100%" }}
							sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
							disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
						>
							Submit
						</LoadingButton>
					</Form.Item>
				</Form>
			}
		/>
	)
}

export default UpdateAccountNumbers;